// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__zdZ14","notification":"styles_notification__RLF43","sidenav":"styles_sidenav__Phi3e"};